exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/_wks-ext.js
// module id = Kh4W
// module chunks = 0